
interface HeroProps {
  onContactClick: () => void;
}

export default function Hero({ onContactClick }: HeroProps) {
  return (
    <div 
      className="relative min-h-screen flex flex-col bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(to right, rgba(15, 94, 126, 0.95) 0%, rgba(15, 94, 126, 0.85) 50%, rgba(15, 94, 126, 0.3) 100%), url('https://public.readdy.ai/ai/img_res/06979191e02929fca73ff6363ed9b3cc.jpg')`
      }}
    >
      <div className="w-full flex justify-center pt-8 pb-4">
        <img 
          src="https://static.readdy.ai/image/a4bf84dbd5adba3766c3686d81e98326/c3e292b273dac3f60365668f88cc8618.png" 
          alt="Plomb'ART Logo" 
          className="w-40 h-40 object-contain"
        />
      </div>

      <div className="flex-1 flex items-center w-full px-6 md:px-12 lg:px-24 py-12">
        <div className="max-w-2xl">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
            L'art du chaud<br />et du froid
          </h1>
          
          <p className="text-xl text-white/90 mb-4 leading-relaxed">
            Entreprise de plomberie diplômée ITS
          </p>
          
          <p className="text-lg text-white/80 mb-8 leading-relaxed">
            Installation, dépannage et rénovation sanitaire à Lyon.<br />
            Savoir-faire artisanal et finitions soignées pour particuliers et professionnels.
          </p>
          
          <div className="flex flex-wrap gap-4">
            <button 
              onClick={onContactClick}
              className="bg-[#F5A623] hover:bg-[#E09612] text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Demander un devis gratuit
            </button>
            <a 
              href="tel:0762551412"
              className="bg-white hover:bg-gray-100 text-[#0F5E7E] px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer flex items-center gap-2"
            >
              <i className="ri-phone-fill"></i>
              Dépannage urgent 7j/7
            </a>
          </div>
          
          <div className="mt-12 flex items-center gap-6 text-white/90">
            <div className="flex items-center gap-2">
              <i className="ri-shield-check-fill text-[#F5A623] text-2xl"></i>
              <span className="text-sm">Diplômé ITS</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-time-fill text-[#F5A623] text-2xl"></i>
              <span className="text-sm">Intervention rapide</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-star-fill text-[#F5A623] text-2xl"></i>
              <span className="text-sm">Qualité garantie</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
